export enum UiControlType {
    Text,
    Date,
    YesNo,
    Dropdown,
    Lookup
}